import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as HyundaiMenuNgrxActions from './hyundai-menu-ngrx.actions';
import { HyundaiMenuNgrxEntity } from './hyundai-menu-ngrx.models';

export const HYUNDAI_MENU_NGRX_FEATURE_KEY = 'hyundaiMenu';

interface AcceptedServiceState {
  [id: string]: string | number;
  status: string;
}

interface DeclinedServiceState {
  [id: string]: string | number;
  declinedReasonId: string;
}

export interface AcceptedServicesState extends EntityState<AcceptedServiceState> {}

export interface DeclinedServicesState extends EntityState<DeclinedServiceState> {}

export const hyundaiMenuAcceptedAdapter: EntityAdapter<any> = createEntityAdapter<AcceptedServiceState>({
  selectId: (services: any) => services.id,
});

export const hyundaiMenuDeclinedAdapter: EntityAdapter<any> = createEntityAdapter<DeclinedServiceState>({
  selectId: (services: any) => services.id,
});

export const initialAcceptedServicesState: AcceptedServicesState = hyundaiMenuAcceptedAdapter.getInitialState({});

export const initialDeclinedServicesState: DeclinedServicesState = hyundaiMenuDeclinedAdapter.getInitialState({});

export interface HyundaiServicesState {
  acceptedServices: AcceptedServicesState;
  declinedServices: DeclinedServicesState;
}

export const initialState: HyundaiServicesState = {
  acceptedServices: initialAcceptedServicesState,
  declinedServices: initialDeclinedServicesState,
};

export interface ServiceLanePartialState {
  readonly [HYUNDAI_MENU_NGRX_FEATURE_KEY]: HyundaiServicesState;
}

const hyundaiMenuNgrxReducer = createReducer(
  initialState,
  on(
    HyundaiMenuNgrxActions.updateServicesForHyundaiMenu,
    (HyundaiServicesState, { acceptedServices, declinedServices }) => {
      return {
        ...HyundaiServicesState,
        acceptedServices: hyundaiMenuAcceptedAdapter.setAll(acceptedServices, {
          ...HyundaiServicesState.acceptedServices,
        }),
        declinedServices: hyundaiMenuDeclinedAdapter.setAll(declinedServices, {
          ...HyundaiServicesState.declinedServices,
        }),
      };
    }
  ),
  on(HyundaiMenuNgrxActions.acceptServiceForHyundaiMenu, (HyundaiServicesState, { acceptedService }) => {
    return {
      ...HyundaiServicesState,
      acceptedServices: hyundaiMenuAcceptedAdapter.addOne(acceptedService, {
        ...HyundaiServicesState.acceptedServices,
      }),
    };
  }),
  on(HyundaiMenuNgrxActions.removeAcceptedServiceFromHyundaiMenu, (HyundaiServicesState, { acceptedService }) => {
    return {
      ...HyundaiServicesState,
      acceptedServices: hyundaiMenuAcceptedAdapter.removeOne(acceptedService, {
        ...HyundaiServicesState.acceptedServices,
      }),
    };
  }),
  on(HyundaiMenuNgrxActions.declineServiceForHyundaiMenu, (HyundaiServicesState, { declinedService }) => {
    return {
      ...HyundaiServicesState,
      declinedServices: hyundaiMenuDeclinedAdapter.upsertOne(declinedService, {
        ...HyundaiServicesState.declinedServices,
      }),
    };
  }),
  on(HyundaiMenuNgrxActions.removeDeclinedServiceFromHyundaiMenu, (HyundaiServicesState, { declinedService }) => {
    return {
      ...HyundaiServicesState,
      declinedServices: hyundaiMenuDeclinedAdapter.removeOne(declinedService, {
        ...HyundaiServicesState.declinedServices,
      }),
    };
  })
);

export function reducer(state: HyundaiServicesState | undefined, action: Action) {
  return hyundaiMenuNgrxReducer(state, action);
}
